
import { useState } from 'react';

const faqs = [
  {
    question: 'Tesis Güvenlik Belgesi nedir ve kimler almalıdır?',
    answer:
      'Tesis Güvenlik Belgesi (TGB), gizlilik dereceli bilgi ve projelere erişim gerektiren savunma sanayi firmalarının alması zorunlu olan bir belgedir. MSB tarafından verilen bu belge, firmanızın güvenlik standartlarını karşıladığını gösterir. Savunma sanayi ihalelerine katılmak isteyen tüm firmalar bu belgeyi almak zorundadır.',
  },
  {
    question: 'Ön değerlendirme süreci nasıl işliyor?',
    answer:
      'Formu doldurduktan sonra uzman ekibimiz firmanızın mevcut durumunu analiz eder. 24 saat içinde sizinle iletişime geçerek ihtiyaçlarınızı detaylı şekilde değerlendirir. Ardından size özel bir ön değerlendirme raporu ve danışmanlık teklifi sunulur. Bu süreç tamamen ücretsizdir.',
  },
  {
    question: 'Belge alma süreci ne kadar sürer?',
    answer:
      'Tesis Güvenlik Belgesi alma süreci firmanızın mevcut durumuna göre değişmekle birlikte, ortalama 3-6 ay arasında tamamlanmaktadır. Fiziki güvenlik altyapısı, personel güvenlik soruşturmaları ve dokümantasyon hazırlığı sürecin ana aşamalarıdır. Profesyonel danışmanlık ile bu süre önemli ölçüde kısaltılabilir.',
  },
  {
    question: 'Milli TGB ile NATO TGB arasındaki fark nedir?',
    answer:
      "Milli Tesis Güvenlik Belgesi, Türkiye'deki gizlilik dereceli projelere katılım için gereklidir ve MSB tarafından verilir. NATO Tesis Güvenlik Belgesi ise NATO üyesi ülkelerin ortak savunma projelerine katılım için gerekli olup, uluslararası standartlara uygunluk aranır. Her iki belge için de farklı gereksinimler ve süreçler mevcuttur.",
  },
  {
    question: 'Danışmanlık ücreti ne kadardır?',
    answer:
      'Danışmanlık ücretimiz firmanızın büyüklüğüne, ihtiyaç duyulan belge türüne ve mevcut altyapı durumunuza göre belirlenmektedir. Ön değerlendirme tamamen ücretsizdir. Detaylı fiyat bilgisi için formu doldurmanız veya doğrudan bizimle iletişime geçmeniz yeterlidir.',
  },
  {
    question: 'Fiziki güvenlik altyapısı konusunda da destek veriyor musunuz?',
    answer:
      'Evet, CCTV kamera sistemleri, erişim kontrol sistemleri, alarm sistemleri, güvenli oda tasarımı ve tüm fiziki güvenlik altyapısı konularında teknik danışmanlık hizmeti sunuyoruz. İhtiyaç analizi, proje tasarımı ve uygulama süreçlerinde yanınızdayız.',
  },
];

export default function AssessmentFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-24 px-8 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-orange-500 text-sm font-semibold uppercase tracking-wider mb-3">
            Sıkça Sorulan Sorular
          </p>
          <h2 className="font-serif text-4xl font-bold text-gray-900 mb-4">
            Merak Edilenler
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto">
            Tesis güvenlik belgesi süreçleri hakkında en çok sorulan soruları sizin için derledik.
          </p>
        </div>

        {/* FAQ schema container */}
        <div
          className="space-y-3"
          itemScope={true}
          itemType="https://schema.org/FAQPage"
        >
          {faqs.map((faq, index) => (
            <div
              key={index}
              itemScope={true}
              itemProp="mainEntity"
              itemType="https://schema.org/Question"
              className={`border rounded-xl overflow-hidden transition-all duration-300 ${
                openIndex === index
                  ? 'border-orange-200 bg-orange-50/30 shadow-sm'
                  : 'border-gray-100 bg-white'
              }`}
            >
              <button
                type="button"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left cursor-pointer"
              >
                <h4
                  itemProp="name"
                  className={`text-base font-semibold pr-4 ${
                    openIndex === index ? 'text-orange-600' : 'text-gray-900'
                  }`}
                >
                  <a href={`#faq-${index}`}>{faq.question}</a>
                </h4>
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-all ${
                    openIndex === index ? 'bg-orange-500 rotate-180' : 'bg-gray-100'
                  }`}
                >
                  <i
                    className={`ri-arrow-down-s-line text-lg ${
                      openIndex === index ? 'text-white' : 'text-gray-500'
                    }`}
                  />
                </div>
              </button>

              {/* Answer block with schema markup */}
              <div
                itemScope={true}
                itemProp="acceptedAnswer"
                itemType="https://schema.org/Answer"
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-6 pb-5">
                  <p
                    itemProp="text"
                    className="text-gray-600 text-sm leading-relaxed"
                  >
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
